import React from 'react';

export default ({name, info, smallName, nameClass, infoClass, children}) =>
    <div className="details-items__item">
        <div className={"item__name " + nameClass}>
            {name}
            {smallName && <small> ({smallName.charAt(0).toUpperCase() + smallName.slice(1)})</small>}
        </div>
        <div className={`item__info item__info--bold ${typeof info === 'string' && info.indexOf('0 ') === 0 ? 'item__info--accent' : ''} ${infoClass ? infoClass : ''}`}>
            {info} {children}
        </div>
    </div>

